import HttpClient from './HttpClient';
import ajax from './ajax';
import axios from 'axios'

export async function getUserDetailsData(data) {
     return ajax('/resources/settings/'+data.user_id+'/')
}

export async function getUserSubscriptionInfo() {
     return ajax('/resources/get-sub-info-fx/', { method: 'POST'})
}

export async function updateUserSubscriptionInfo(data) {
     return ajax('/resources/update-sub-info-fx/', { method: 'POST', data })
}

export async function updateSubscription(data) {
     return ajax('/resources/update-subscription/', { method: 'POST', data })
}

export async function getDeleteUserIp(data) {
     return ajax('/resources/settings/'+data.user_id+'/', { method: 'POST', data })
}

export async function updateUserDetailsInSettings(data) {
     return ajax('/resources/settings/'+data.user_id+'/', { method: 'POST', data })
}

export async function sendOtpforPasswordChange(data) {
     return ajax('/resources/settings-change-password/', { method: 'POST', data })
}

export async function userPasswordChange(data) {
     return ajax('/resources/change/password/', { method: 'POST', data })
}

export async function getChatgptCredits() {
     return ajax('/resources/chatgpt-credits/')
}

export async function addMoreChatgptCredits(data) {
     return ajax('/resources/chatgpt-credits/', { method: 'POST', data})
}
